module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921012649_T.2422ee4c.jpg";